// @flow
import React, { type Node } from 'react';

import Order, { type OrderProps } from './Order';
import OrderData, { type OrderDataProps } from '../../OrderData';


type Props = {
  ...$Diff<$Exact<OrderDataProps>, { children: Node | void }>,
  ...OrderProps,
}

const OrderRoot = (props: Props) => {
  const { id } = props;

  return (
    <OrderData id={id}>
      <Order {...props} />
    </OrderData>
  );
};

export default OrderRoot;
